import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        klarnaPlacement: {
            '#klarna-placement::part(osm-container)': {
                width: '100%',
                display: 'flex',
                height: remCalc(59),
                padding: remCalc(16),
                borderRadius: ['medium.base', 'medium.sm', 'medium.md', 'medium.lg'],
                border: 'small',
                borderStyle: 'solid',
                borderColor: 'border.light',
                backgroundColor: 'background.default',
                alignItems: 'center',
                gap: remCalc(2),
            },
            '#klarna-placement::part(osm-message)': {
                textStyle: 'body-small',
                color: 'text.default',
                fontWeight: 'normal',
                _hover: {
                    textDecoration: 'none',
                },
                _focus: {
                    boxShadow: 'outline',
                },
            },
            '#klarna-placement::part(osm-cta)': {
                textStyle: 'body-xsmall',
                color: 'text.default',
                fontWeight: 'normal',
                id: 'klarna-cta-link',
            },
            '#klarna-placement::part(osm-legal)': {
                display: 'none',
            },
        },
    },
    variants: {
        cart: {
            klarnaPlacement: {
                '#klarna-placement::part(osm-container)': {
                    display: 'unset',
                    width: '100%',
                    backgroundColor: 'transparent',
                    height: 'unset',
                    padding: 'unset',
                    borderRadius: 'unset',
                    border: 'unset',
                    borderStyle: 'unset',
                    borderColor: 'unset',
                    alignItems: 'unset',
                    gap: 'unset',
                },
                '#klarna-placement::part(osm-message)': {
                    color: 'text.default',
                    marginLeft: remCalc(-14),
                    textStyle: 'body-xsmall',
                },
                '#klarna-placement::part(osm-cta)': {color: 'text.light'},
                '#klarna-placement::part(osm-badge-container)': {display: 'none'},
            },
        },
    },
}
